import React, { useRef } from 'react';
import ReplayIcon from '@mui/icons-material/Replay';
import { continueAngle, toCss } from '../geometry';

type RotateButtonProps = {
  level: 'puzzle' | 'grid' | 'quadrant' | 'subgrid';
  /** The element that undoes the piece's screen orientation, so the icon reads upright. */
  upright: number;
  onRotate: (clockwise: boolean) => void;
};

/**
 * A clockwise-turn button. Left click turns clockwise, right click counterclockwise. The
 * arrow is counter-transformed like the letters so it always shows a clockwise arrow no
 * matter how the piece it sits on has been turned or mirrored.
 */
const RotateButton = ({ level, upright, onRotate }: RotateButtonProps) => {
  const { angle, flip } = toCss(upright);
  const previousAngle = useRef(angle);
  const continued = continueAngle(previousAngle.current, angle);
  previousAngle.current = continued;

  // The Replay glyph is a counterclockwise arrow; mirroring it once makes it clockwise.
  const iconStyle: React.CSSProperties = {
    transform: `rotate(${continued}deg) scaleX(${flip ? 1 : -1})`,
  };

  return (
    <button
      type="button"
      className={`ultraRotateButton ${level}`}
      onClick={() => onRotate(true)}
      onContextMenu={(e) => {
        e.preventDefault();
        onRotate(false);
      }}
    >
      <span className="ultraRotateIcon" style={iconStyle}>
        <ReplayIcon/>
      </span>
    </button>
  );
};

export default RotateButton;
